import { AssetGroupStatus, NetworkMeasurementType } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/index.ts";

export const AssetGroupStatusOptions = convertMapToOpts(
  AssetGroupStatus,
  ([_, value]) => toTitleCaseString(value)
);

export const NetworkMeasurementTypeOptions = convertMapToOpts(
  NetworkMeasurementType,
  ([_, value]) => toTitleCaseString(value)
);
